'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWhatshot = function MdWhatshot(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 31.6c4.5 0 8-3.5 8-7.9 0-2.4-0.3-4.6-0.9-6.7-1.8 2.2-4.8 3.6-7.8 4.3s-4.7 2.4-4.7 5.1c0 2.9 2.5 5.2 5.4 5.2z m3-30.5c6.5 5.2 10.9 13.3 10.9 22.3 0 7.3-6.1 13.2-13.4 13.2s-13.4-5.9-13.4-13.2c0-5.7 2.1-10.9 5.4-14.9v0.6c0 3.5 2.6 6.2 6 6.2s5.7-2.7 5.7-6.2c0-3.6-1.2-8-1.2-8z' })
        )
    );
};

exports.default = MdWhatshot;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/whatshot.js
// module id = 2137
// module chunks = 168707334958949